export default __webpack_public_path__ + "static/media/Mitr-Regular.f73e4ca6.ttf";